
/* ********************************
SVG Animations 
********************************* */
anime({
	targets: '.ola-slider path',
	d: [
		//2
		{
			value: 'm0 40.865s262.16 77.245 512.76 56.6c269.22-22.179 580.43-64.998 845.31-30.292 264.88 34.706 563.93 69.827 563.93 69.827l-1 37-1920 1z'
		},
		//3
		{  
			value: 'm0 62.865s233.55 77.85 512.76 28.6c266.03-46.926 580.43-42.998 845.31-8.292 264.88 34.706 563.93 41.827 563.93 41.827l-1 49-1920 1z' 
		},
		//4
		{  
			value: 'm0 84.865s195.41 50.747 512.76-9.3997c265.41-50.304 554.55-17.17 845.31 25.708 290.76 42.878 563.93 9.8271 563.93 9.8271l-1 63-1920 1z' 
		},
		//5
		{  
			value: 'm0 104.86s195.41 12.747 512.76-47.4c265.41-50.304 555.92 35.348 845.31 53.708 289.4 18.36 563.93-18.173 563.93-18.173l-1 81-1920 1z' 
		},
		//6
		{  
			value: 'm0 112.86s190.66-42.235 512.76-66.297c272.22-20.336 580.43 90.472 845.31 74.778 264.88-15.694 563.93-38.346 563.93-38.346l-1 91-1920 1z' 
		},
		//7
		{  
			value: 'm0 102.86s213.12-65.912 512.76-63.4c270.12 2.2647 540.93 126.99 845.31 67.708 304.38-59.283 563.93-30.173 563.93-30.173l-1 97-1920 1z' 
		},
		//8
		{  
			value: 'm0 80.865s220.54-87.861 512.76-33.4c255.34 47.588 472.82 108.99 845.31 49.708 372.49-59.283 563.93-24.173 563.93-24.173l-1 101-1920 1z' 
		},
		//9
		{  
			value: 'm0 42.865s168.56-56.624 511.39 27.238c290.72 71.115 494.62 76.818 846.67 12.086 352.05-64.732 563.93 12.811 563.93 12.811l-1 79-1920 1z' 
		},
		//10
		{  
			value: 'm0 20.865s216.24 9.3438 511.39 63.238c294.43 53.761 493.26 17.402 846.67-11.914 353.42-29.316 563.93 38.811 563.93 38.811l-1 63-1920 1z' 
		},
		//11
		{  
			value: 'm0 7.2431s213.35 61.45 511.39 95.93c299.88 34.691 493.26-34.36 846.67-37.794 353.42-3.4348 563.93 55.622 563.93 55.622l-1 53-1920 1z' 
		},
		//1
		{  
			value: 'm0 0s258.07 109.94 514.12 107c270.12-3.0979 587.97-50.014 844.68-50.724 256.7-0.71051 563.21 74.724 563.21 74.724l-1 43-1920 1z' 
		}
	],
	loop: true,
	easing: 'linear',
	duration: '9000',
});

anime({
	targets: '.line-slider path',
	d: [
		//2
		{
			value: 'm0 40.865s262.16 77.245 512.76 56.6c269.22-22.179 580.43-64.998 845.31-30.292 264.88 34.706 563.93 69.827 563.93 69.827l-1 37-1920 1z'
		},
		//3
		{  
			value: 'm0 62.865s233.55 77.85 512.76 28.6c266.03-46.926 580.43-42.998 845.31-8.292 264.88 34.706 563.93 41.827 563.93 41.827l-1 49-1920 1z' 
		},
		//4
		{  
			value: 'm0 84.865s195.41 50.747 512.76-9.3997c265.41-50.304 554.55-17.17 845.31 25.708 290.76 42.878 563.93 9.8271 563.93 9.8271l-1 63-1920 1z' 
		},
		//5
		{  
			value: 'm0 104.86s195.41 12.747 512.76-47.4c265.41-50.304 555.92 35.348 845.31 53.708 289.4 18.36 563.93-18.173 563.93-18.173l-1 81-1920 1z' 
		},
		//6
		{  
			value: 'm0 112.86s190.66-42.235 512.76-66.297c272.22-20.336 580.43 90.472 845.31 74.778 264.88-15.694 563.93-38.346 563.93-38.346l-1 91-1920 1z' 
		},
		//7
		{  
			value: 'm0 102.86s213.12-65.912 512.76-63.4c270.12 2.2647 540.93 126.99 845.31 67.708 304.38-59.283 563.93-30.173 563.93-30.173l-1 97-1920 1z' 
		},
		//8
		{  
			value: 'm0 80.865s220.54-87.861 512.76-33.4c255.34 47.588 472.82 108.99 845.31 49.708 372.49-59.283 563.93-24.173 563.93-24.173l-1 101-1920 1z' 
		},
		//9
		{  
			value: 'm0 42.865s168.56-56.624 511.39 27.238c290.72 71.115 494.62 76.818 846.67 12.086 352.05-64.732 563.93 12.811 563.93 12.811l-1 79-1920 1z' 
		},
		//10
		{  
			value: 'm0 20.865s216.24 9.3438 511.39 63.238c294.43 53.761 493.26 17.402 846.67-11.914 353.42-29.316 563.93 38.811 563.93 38.811l-1 63-1920 1z' 
		},
		//11
		{  
			value: 'm0 7.2431s213.35 61.45 511.39 95.93c299.88 34.691 493.26-34.36 846.67-37.794 353.42-3.4348 563.93 55.622 563.93 55.622l-1 53-1920 1z' 
		},
		//1
		{  
			value: 'm0 0s258.07 109.94 514.12 107c270.12-3.0979 587.97-50.014 844.68-50.724 256.7-0.71051 563.21 74.724 563.21 74.724l-1 43-1920 1z' 
		}
	],
	loop: true,
	easing: 'linear',
	duration: '9000',
});

anime({
	targets: '.line-intro',
	startOffset: [
		{
			value: '-200%'
		},
	],
	loop: true,
	easing: 'linear',
	duration: '60000',
});